import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMaleGlyphSecondary from './svgs/MaleGlyphSecondary.js';
import SvgMaleGlyph from './svgs/MaleGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var maleGlyph = (props => useIcon(SvgMaleGlyph, SvgMaleGlyphSecondary, props));

export { maleGlyph as default };
